export default "__VITE_ASSET__CTrVFtyJ__"